module.exports = __webpack_public_path__ + "static/media/employeetracking.a84fb6e2.jpg";